import * as Yup from "yup";

import { IBasicEntity } from "../../../core/models";
import { IClient } from "../../client/data/entities";
import { ETransactionType } from "./models";

export interface IBasicTransactionForm {
  amount: number;
  clientId: string;
  type: ETransactionType.GIVE | ETransactionType.RECIEVE; // | ETransactionType.SALARY;
}

export interface IBasicTransaction extends IBasicEntity {
  client: IClient;
  amount: number;
  type: ETransactionType.GIVE | ETransactionType.RECIEVE | ETransactionType.EXPENSE;
}

const basicTransactionCommonValidation = {
  clientId: Yup.string().required(),
  amount: Yup.number()
    .min(1)
    .required(),
  type: Yup.mixed()
    .oneOf([
      ETransactionType.GIVE,
      ETransactionType.RECIEVE,
      //ETransactionType.SALARY
    ])
    .required(),
};

export const basicTransactionFormValidation = Yup.object<IBasicTransactionForm>({
  ...basicTransactionCommonValidation,
});

// export const transactionEditFormValidation = Yup.object<IBasicTransactionForm>({
//   ...basicTransactionCommonValidation,
// });

export const basicTransactionToJson = (form: IBasicTransactionForm): any => {
  return {
    client: {
      id: form.clientId.toString(),
    },
    amount: parseFloat(form.amount.toString()),
    type: form.type.toString(),
  };
};
